import {useState, useEffect} from 'react';
import {useAppDispatch} from "@/app/hooks";
import {AuthRequests, VerifyOtpModel, VerifyOtpResponseModel} from "@/app/api/auth";
import {SearchParamsKey, useUrlParams} from "@/app/utils/search_params";
import {AuthScreenStatus, setState} from "@/app/features/auth";

const useOtp = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const {setUrlParam, getUrlParam} = useUrlParams();

  const dispatch = useAppDispatch();

  useEffect(() => {
  }, []);

  const updateCode = async (newPhone: string) => {
    setCode(newPhone);
  };

  const verification = async () => {
    try {
      setLoading(true);
      const phone: string | null = getUrlParam(SearchParamsKey.phone);
      const model: VerifyOtpModel = {otp: code, phoneNumber: phone ?? ''};
      const response: VerifyOtpResponseModel = await AuthRequests.verifyOtp(model);
      if (!response.userExists && response.otpValid) {
        dispatch(setState(AuthScreenStatus.CREATE_PIN));
      } else if (response.userExists && response.otpValid) {
        dispatch(setState(AuthScreenStatus.PIN));
      }
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const codeContainAllDigits = () => {
    return code.length != 4;
  }

  const startTimer = () => {
    if (timer !== 0) return;
    setTimer(59);
  };

  useEffect(() => {
    let interval: number | null = null;

    if (timer > 0) {
      interval = window.setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      if (interval !== null) {
        clearInterval(interval);
      }
    };
  }, [timer]);

  const getTimeString = () => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${minutes.toString().padStart(1, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return {
    code: code,
    setCode: updateCode,
    loading,
    error,
    verification: verification,
    codeContainAllDigits: codeContainAllDigits,
    timer: timer,
    startTimer: startTimer,
    getTimeString: getTimeString
  };
};

export default useOtp;